module.exports = __webpack_public_path__ + "media/images/flags/GW-3121fd411390b8057148ec0cd1da4f80.svg";